import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import UserAvatar from 'react-user-avatar';
import MaterialIcon from 'material-icons-react';
// Components
import DrawerToggleButton from '../DrawerToggleButton';
import InviteHeader from '../InviteHeader';
// Images
import logo from '../../images/TrevelLogoText.svg';
import beta from '../../images/beta.png';
// Sagas
import { getLocations } from '../../sagas/locationsSaga/reducer';
import { init as getPackages } from '../../sagas/packagesSaga/reducer';
import { getTimedEvents } from '../../sagas/timedEventsSaga/reducer';

import './Toolbar.css';

export class AuthTopBar extends React.Component {
  constructor() {
    super();
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.openLocationChooser = this.openLocationChooser.bind(this);
    this.closeLocationChooser = this.closeLocationChooser.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.confirmLocationChange =
      this.confirmLocationChange.bind(this);
    this.state = {
      loading: true,
      location: 'St. Louis',
      zoneId: 11,
      showLocationChooser: false,
      pendingLocation: 'St. Louis',
      pendingZoneId: 11,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.profile !== prevState.profile) {
      const zoneId = nextProps.profile.zoneId || 11;
      const location = zoneId === 10 ? 'Kansas City' : 'St. Louis';
      return {
        profile: nextProps.profile,
        location,
        zoneId,
      };
    }
    return null;
  }

  componentDidMount() {
    if (this.props.profile.profilePhotoPath !== undefined) {
      this.setState({
        avatarURL: this.props.profile.profilePhotoPath,
        loading: false,
      });
    }
    const storedZoneId = localStorage.getItem('selectedZoneId');
    if (storedZoneId) {
      const zoneId = parseInt(storedZoneId, 10);
      const location = zoneId === 10 ? 'Kansas City' : 'St. Louis';
      this.setState({
        location,
        zoneId,
        pendingLocation: location,
        pendingZoneId: zoneId,
      });
    }
  }

  handleLocationChange(event) {
    const location = event.target.value;
    const zoneId = location === 'Kansas City' ? 10 : 11;
    this.setState({ location, zoneId }, () => {
      localStorage.setItem('selectedZoneId', zoneId);
      this.props.getLocations(zoneId);
      this.props.getPackages(zoneId);
      this.props.getTimedEvents(zoneId);
    });
  }

  openLocationChooser() {
    this.setState({
      showLocationChooser: true,
      pendingLocation: this.state.location,
      pendingZoneId: this.state.zoneId,
    });
  }

  closeLocationChooser() {
    this.setState({ showLocationChooser: false });
  }

  selectLocation(location) {
    const zoneId = location === 'Kansas City' ? 10 : 11;
    this.setState({
      pendingLocation: location,
      pendingZoneId: zoneId,
    });
  }

  confirmLocationChange() {
    const location =
      this.state.pendingLocation || this.state.location;
    const zoneId = this.state.pendingZoneId || this.state.zoneId;
    this.setState(
      {
        location,
        zoneId,
        showLocationChooser: false,
      },
      () => {
        localStorage.setItem('selectedZoneId', zoneId);
        this.props.getLocations(zoneId);
        this.props.getPackages(zoneId);
        this.props.getTimedEvents(zoneId);
      },
    );
  }

  locationDropdown() {
    return (
      <div className="toolbar__location">
        <div className="location-current">
          <span className="location-current-text">
            <MaterialIcon icon="place" size={16} />{' '}
            {this.state.location}
          </span>
          <button
            type="button"
            className="location-change-link"
            onClick={this.openLocationChooser}
          >
            Change
          </button>
        </div>
        {this.state.showLocationChooser && (
          <div className="location-modal-backdrop">
            <div className="location-modal">
              <button
                type="button"
                className="location-modal-close"
                onClick={this.closeLocationChooser}
                aria-label="Close"
              >
                ×
              </button>
              <div className="location-modal-header">
                Choose Location
              </div>
              <div className="location-modal-list">
                <button
                  type="button"
                  className={
                    this.state.pendingLocation === 'St. Louis'
                      ? 'location-option selected'
                      : 'location-option'
                  }
                  onClick={() => this.selectLocation('St. Louis')}
                >
                  <span>St. Louis</span>
                  <span className="location-option-icon">
                    <MaterialIcon icon="place" size={18} />
                  </span>
                </button>
                <button
                  type="button"
                  className={
                    this.state.pendingLocation === 'Kansas City'
                      ? 'location-option selected'
                      : 'location-option'
                  }
                  onClick={() => this.selectLocation('Kansas City')}
                >
                  <span>Kansas City</span>
                  <span className="location-option-icon">
                    <MaterialIcon icon="place" size={18} />
                  </span>
                </button>
              </div>
              <div className="location-modal-actions">
                <button
                  type="button"
                  className="location-modal-cancel"
                  onClick={this.closeLocationChooser}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="location-modal-confirm"
                  onClick={this.confirmLocationChange}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return null; // or render a loading icon
    }
    return (
      <div
        className={
          this.props.profile.userType !== 1 &&
          this.props.profile.userType !== 3
            ? 'toolbar authtoolbar'
            : 'toolbar authtoolbar'
        }
        id="authtoolbar"
      >
        {/* {(this.props.profile.userType === 1 ||
          this.props.profile.userType === 3 ||
          this.props.profile.userType === 4) && (
          <div id="vendorTopLink">
            <a href="/vendor/home">Open Trevel Experiences</a>
          </div>
        )} */}

        {(this.props.profile.userType === 1 ||
          this.props.profile.userType === 3 ||
          this.props.profile.userType === 4) && (
          <div id="vendorTopLink">
            <Link
              to={{
                pathname: '/feedback',
              }}
              style={{ textDecoration: 'underline' }}
            >
              Provide Feedback
            </Link>
          </div>
        )}

        <nav className="toolbar__navigation" id="mobile-nav">
          <Container>
            <Row>
              <Col xs={2} md={2} sm={2} lg={2} className="no-padding">
                <div className="toolbar__toggle-button">
                  <DrawerToggleButton
                    click={this.props.drawerClickHandler}
                  />
                </div>
              </Col>
              <Col xs={8} md={8} sm={8} lg={8}>
                <center>
                  <div className="toolbar__logo">
                    <Link
                      to={{
                        pathname: '/home',
                      }}
                    >
                      {/* <img src={beta} /> */}
                      <img src={logo} />
                    </Link>
                  </div>
                </center>
              </Col>
              <Col xs={2} md={2} sm={2} lg={2} className="no-padding">
                <Link
                  to={{
                    pathname: '/profile/edit',
                  }}
                >
                  <UserAvatar
                    size="44"
                    name={
                      this.props.profile.firstName +
                      this.props.profile.lastName
                    }
                    src={this.state.avatarURL}
                    style={{
                      float: 'right',
                      color: 'white',
                    }}
                  />
                </Link>

                <InviteHeader />
              </Col>
            </Row>
          </Container>
        </nav>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    profile: state.profile.profile,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getLocations: (zoneId) => {
      dispatch(getLocations(zoneId));
    },
    getPackages: (zoneId) => {
      dispatch(getPackages(zoneId));
    },
    getTimedEvents: (zoneId) => {
      dispatch(getTimedEvents(zoneId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuthTopBar);

// Drop Down
{
  /* <div className="eventDropDown"> */
}

{
  /* <div className="dropdown-content">
          <li>
            <a href="/packages">Romantic</a>
          </li>
          <li>
            <a href="/packages ">Adventurous</a>
          </li>
          <li>
            <a href="/packages ">Category</a>
          </li>
        </div> */
}
{
  /* </div> */
}
